import React, { useMemo } from 'react';
interface FloatingElementsProps {
  count?: number;
  variant?: 'money' | 'danger';
}
export function FloatingElements({
  count = 8,
  variant = 'money'
}: FloatingElementsProps) {
  const color = variant === 'danger' ? 'rgba(220, 38, 38, 0.08)' : 'rgba(0, 200, 83, 0.1)';
  const symbolColor = variant === 'danger' ? 'rgba(220, 38, 38, 0.12)' : 'rgba(0, 200, 83, 0.15)';
  const elements = useMemo(() => {
    return Array.from({
      length: count
    }, (_, i) => {
      const type = i % 3 === 0 ? 'dollar' : i % 3 === 1 ? 'coin' : 'bill';
      return {
        id: i,
        type,
        size: type === 'dollar' ? 18 + i * 7 % 16 : type === 'coin' ? 12 + i * 5 % 10 : 16 + i * 3 % 8,
        x: (i * 37 + 11) % 90 + 5,
        y: (i * 53 + 7) % 85 + 5,
        duration: 12 + i * 3 % 10,
        delay: i * 1.3 % 5,
        dx: 6 + i * 4 % 12,
        dy: -(8 + i * 5 % 14),
        rot: i * 47 % 360
      };
    });
  }, [count]);
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-19">
      {elements.map(el => <div key={el.id} className="absolute floating-el" style={{
      left: `${el.x}%`,
      top: `${el.y}%`,
      '--duration': `${el.duration}s`,
      '--delay': `${el.delay}s`,
      '--dx': `${el.dx}px`,
      '--dy': `${el.dy}px`,
      '--rot': `${el.rot}deg`
    } as React.CSSProperties} data-id="element-20">
          {el.type === 'dollar' && <span style={{
        fontSize: el.size,
        color: symbolColor,
        fontWeight: 800
      }} data-id="element-21">
              $
            </span>}
          {el.type === 'coin' && <svg width={el.size} height={el.size} viewBox="0 0 20 20" data-id="element-22">
              <circle cx="10" cy="10" r="9" fill={color} stroke={symbolColor} strokeWidth="1" data-id="element-23" />
              <text x="10" y="14" textAnchor="middle" fill={symbolColor} fontSize="10" fontWeight="bold" data-id="element-24">
                $
              </text>
            </svg>}
          {el.type === 'bill' && <svg width={el.size * 1.6} height={el.size} viewBox="0 0 32 20" data-id="element-25">
              <rect x="1" y="1" width="30" height="18" rx="2" fill={color} stroke={symbolColor} strokeWidth="0.8" data-id="element-26" />
              <text x="16" y="14" textAnchor="middle" fill={symbolColor} fontSize="10" fontWeight="bold" data-id="element-27">
                $
              </text>
            </svg>}
        </div>)}
    </div>;
}